import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Result } from 'src/shared/model/result';
import { User_api } from 'src/user/constant/user-const';
import { ConsumerLogin } from 'src/user/model/consumer-login';
import { ConsumerRegistration } from 'src/user/model/consumer-registration';
import { LoginResponse } from 'src/user/model/login.response.model';
import { ResponseModel } from '@shared/model/ApiResponses/ConsumerPortal/response-model';
import { IConsumerInformation } from '@shared/model/ApiResponses/ConsumerPortal/consumer-information.model';
import { StatefulService } from '@app/service/stateful.service';
import { ApiService } from '@workflow/ecp-shared/service/api/api.service';
import { UserSettings } from '@workflow/ecp-shared/model/userinfo';
import { RequestHeaderConst } from '@workflow/ecp-shared/constant/information.const';

/**
 * ConsumerUserService handles login, registration, econsent
 */
@Injectable({
  providedIn: 'root'
})
export class ConsumerUserService {
  constructor(private api: ApiService, private readonly statefulService: StatefulService) {}

  public login(login: ConsumerLogin, oldSession: string): Observable<Result<LoginResponse>> {
    User_api.LogIn.defaultHeaders = oldSession
      ? { [RequestHeaderConst.authorization]: this.statefulService.wrap('ss:authorization').valueString, Persistedtoken: oldSession }
      : { [RequestHeaderConst.authorization]: this.statefulService.wrap('ss:authorization').valueString };
    return this.api.request<Result<LoginResponse>>({
      body: login,
      urlObj: User_api.LogIn
    });
  }

  public registration(registration: ConsumerRegistration): Observable<Result<ConsumerRegistration>> {
    return this.api.request<Result<ConsumerRegistration>>({
      body: registration,
      urlObj: User_api.Register
    });
  }

  public updateSettings(userSettings: UserSettings): Observable<UserSettings> {
    return this.api.request<UserSettings>({
      body: userSettings,
      urlObj: User_api.UpdateSettings
    });
  }

  public startNewApplication(queryParam?: { [key: string]: string }): Observable<ResponseModel<IConsumerInformation>> {
    return this.api.request({
      urlObj: User_api.StartNewApplication,
      body: {},
      queryParam
    });
  }

  public LinkLoan(login: ConsumerLogin): Observable<Result<LoginResponse>> {
    return this.api.request<Result<LoginResponse>>({
      body: login,
      urlObj: User_api.LinkLoan
    });
  }
}
